import {Controller} from '@hotwired/stimulus';

export default class extends Controller {

    setupNavigation(form) {
        const navForwardBtn = document.getElementById('forward-nav-button-li');
        const navStayBtn = document.getElementById('stay-nav-button-li');
        const navBackBtn = document.getElementById('back-nav-button-li');

        navForwardBtn?.querySelector('a').addEventListener('click', () => {
            form.querySelector('input[type="submit"]').click();
        });

        navStayBtn?.querySelector('a').addEventListener('click', () => {
            document.getElementById('person_survey_completed')?.setAttribute('value', '0');
            form.insertAdjacentHTML('beforeend', '<input type="hidden" name="direction" value="stay">');
            form.querySelector('input[type="submit"]').click();
        });

        navBackBtn?.querySelector('a').addEventListener('click', () => {
            document.getElementById('person_survey_completed')?.setAttribute('value', '0');
            form.insertAdjacentHTML('beforeend', '<input type="hidden" name="direction" value="step-back">');
            form.querySelector('input[type="submit"]').click();
        });
    }

    setupTimeWishToggle = () => {
        // Frage 'Ich benötige zwingend frei'
        this.addToggleListener('zeitwunsch_option', 'zeitwunsch_option_section', false, (v) => {
            const section = document.querySelector('.zeitwunsch_option_section');
            const selectedTexts = document.querySelector('.selected-texts');
            const remarks = document.querySelector('.remarks');
            const submitBtn = document.querySelector('.save-next');

            if (v === 0) {
                section.classList.add('hidden');
                selectedTexts.classList.add('hidden');
                remarks.classList.add('hidden');
            } else {
                section.classList.remove('hidden');
                selectedTexts.classList.remove('hidden');
                remarks.classList.remove('hidden');
                submitBtn.classList.remove('hidden');
            }
        });
    }

    // =========================================================
    // ==== UX / styling / materializecss /workarounds
    // =========================================================

    reInitializeMaterializeCss() {
        // Stimulus controller 'materializecss-init' / materializecss_init_controller.js
        // noinspection JSUnresolvedReference
        this.application
            .getControllerForElementAndIdentifier(this.element, 'materializecss-init')
            .reInitializeMaterializeCss(document.getElementById('view_step'));
    }

    setupResetButton() {
        document
            .getElementById('reset-button')
            ?.addEventListener('click', () => location.reload());
    }

    addToggleListener(toggle, div_class, toggle_on_0, callback) {
        const section = document.querySelector(`.${div_class}`);

        const toggle0 =
          document.getElementById(`person_survey_${toggle}_0`) ||
          document.getElementById(`person_survey_sl_${toggle}_0`)

        const toggle1 =
          document.getElementById(`person_survey_${toggle}_1`) ||
          document.getElementById(`person_survey_sl_${toggle}_1`)

        toggle0?.addEventListener('click', () => {
              if (section && toggle_on_0) section.classList.remove('hidden')
              if (section && !toggle_on_0) section.classList.add('hidden')
              callback?.(0);
        });

        toggle1?.addEventListener('click', () => {
            if (section && toggle_on_0) section.classList.add('hidden')
            if (section && !toggle_on_0) section.classList.remove('hidden')
            callback?.(1);
        });
    }
}